import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import AccountPageMenuDesktop from '../AccountPageMenuDesktop';
import AccountPageMenuMobile from '../AccountPageMenuMobile';

const Wrapper = styled.div``;

export default function AccountPageMenu({ title, ...rest }) {
  return (
    <Wrapper {...rest}>
      <AccountPageMenuMobile title={title} />
      <AccountPageMenuDesktop />
    </Wrapper>
  );
}

AccountPageMenu.propTypes = {
  title: PropTypes.string,
};
